import React from "react";
import AddClothes from "./AddClothes";

const ManageClothes = () => {
  return (
    <div className="container mx-auto">
      <AddClothes></AddClothes>
    </div>
  );
};

export default ManageClothes;
